export default "__VITE_ASSET__oLcLdZgt__"